import moment from "moment";
import { AnyAction } from "redux";

const DATE_FORMAT_DDMMYYYY = "DDMMYYYY";
const DATE_FORMAT_DDMMYYYY_WITH_SEPARATION = (separator: string) => ["DD", "MM", "YYYY"].join(separator);

export const isValidJSON = (str: string) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export const pending = (actionType: string) => {
    return `${actionType}_PENDING`;
};
export const fulfilled = (actionType: string) => {
    return `${actionType}_FULFILLED`;
};
export const rejected = (actionType: string) => {
    return `${actionType}_REJECTED`;
};

export const isStartingAjaxCall = (action: AnyAction) => {
    return action.type.endsWith("_PENDING");
};

export const isFailedAjaxCall = (action: AnyAction) => {
    return action.type.endsWith("_REJECTED");
};

/**
 * Helper function for isValidSubscriptionAge.
 *
 *  Oppbygging av fødselsnummeret
 *   Fødselsnummeret består av 11 siffer.
 *     De seks første sifrene viser fødselsdato i rekkefølgen dato, måned, år.
 *     De tre neste sifrene er individnummer hvor det tredje nummeret viser til kjønn, partall betegner kvinne og oddetall betegner mann.
 *     De to siste sifrene er kontrollsiffer.
 *     Personnummer er de fem siste sifrene i fødselsnummeret.
 *     De tre sifrene som er individnummeret, tildeles fortløpende innen den enkelte fødselsdato. Som individsiffer for personer født…
 * a) … 1854-1899, brukes serien 749-500,
 * b) … 1900-1999, brukes serien 499-000,
 * c) … 1940-1999, brukes også serien 999-900
 * d) … 2000-2039, brukes serien 999-500.
 */
export const getBirthDateFromSSN = (
    ssn?: string,
    format = DATE_FORMAT_DDMMYYYY_WITH_SEPARATION("."),
): string | undefined => {
    if (!ssn) {
        return undefined;
    }

    let fullYear;
    const twoDigitYear = parseInt(ssn.substring(4, 6));
    const ssnIndividualPart = parseInt(ssn.substring(6, 9));

    if (ssnIndividualPart >= 0 && ssnIndividualPart < 500) {
        fullYear = 1900 + twoDigitYear;
    } else if (ssnIndividualPart > 499 && ssnIndividualPart < 750 && twoDigitYear >= 54 && twoDigitYear < 100) {
        fullYear = 1800 + twoDigitYear;
    } else if (ssnIndividualPart > 499 && ssnIndividualPart <= 999 && twoDigitYear >= 0 && twoDigitYear < 40) {
        fullYear = 2000 + twoDigitYear;
    } else if (ssnIndividualPart > 899 && ssnIndividualPart <= 999 && twoDigitYear > 39 && twoDigitYear < 100) {
        fullYear = 1900 + twoDigitYear;
    }
    if (!fullYear) return undefined;
    return moment(ssn.substring(0, 4) + fullYear.toString(), DATE_FORMAT_DDMMYYYY).format(format);
};

export const PhoneNumberFormatters = [
    {
        displayFormat: "XXX XX XXX",
        displayFn: (phoneNumber: string) => {
            const onlyDigits = (phoneNumber || "").replace(/\s/g, "");
            return onlyDigits.substr(0, 3) + " " + onlyDigits.substr(3, 2) + " " + onlyDigits.substr(5, 3);
        },
    },
    {
        displayFormat: "XX XX XX XX",
        displayFn: (phoneNumber: string) => {
            return (
                phoneNumber.substr(0, 2) +
                " " +
                phoneNumber.substr(2, 2) +
                " " +
                phoneNumber.substr(4, 2) +
                " " +
                phoneNumber.substr(6, 2)
            );
        },
    },
    {
        displayFormat: "XXXXXXXX",
        displayFn: (phoneNumber: string) => {
            return phoneNumber;
        },
    },
    {
        displayFormat: "XXXX XXXX XXXX",
        displayFn: (phoneNumber: string) => {
            let onlyDigits = (phoneNumber || "").replace(/\s/g, "");
            onlyDigits = onlyDigits.replace(/(\d{1,4})(\d{0,4})(\d{0,4})/, "$1 $2 $3").trim();
            return onlyDigits.substr(0, 14);
        },
    },
    {
        displayFormat: "+XX XXX XX XXX",
        displayFn: (phoneNumber: string) => {
            let onlyDigits = (phoneNumber || "").replace(/\s|\+/g, "");
            onlyDigits = onlyDigits.replace(/(\d{2})(\d{3})(\d{2})(\d{3})/, "+$1 $2 $3 $4").trim();
            return onlyDigits.substr(0, 14);
        },
    },
];
